import Vue from 'vue'
import Vuex from 'vuex'
import MineApi from '@/api/mine';

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        unReadNum: 0
    },
    mutations: {
        // 更新未读消息数量
        setUnReadNum(state, num) {
            state.unReadNum = num;
        }
    },
    actions: {
        // 异步获取未读消息数并提交
        async fetchUnReadNum({ commit }) {
            const res = await MineApi.getSocialMediaKitListNoCount();
            commit('setUnReadNum', +res.data);
        }
    }
})